import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CommonApiService } from '../core/services/common-api.service';
import { ToastrService } from 'ngx-toastr';
import { isHubSpotUrl } from '@app/hubspot/utils/packet-id.util';

@Component({
  selector: 'app-i18n',
  standalone: true,
  imports: [],
  templateUrl: './i18n.component.html',
  styleUrl: './i18n.component.css'
})
export class I18nComponent {
  isDropdownOpen = false;
  selectedLang: any;
  languages = signal<any>([]);
  userId = signal<any>('')

  constructor(
    private translateService: TranslateService,
    private api: CommonApiService,
    private toastr: ToastrService,
    private router: Router,
  ) {
    this.translateService.setDefaultLang('en-US');
    this.userId.set(localStorage.getItem('userId'));

    // HubSpot iframe has no MasterLanguage / UserLanguage endpoints (404).
    if (isHubSpotUrl(this.router.url)) {
      this.selectedLang = { locale: 'en-US', languageCode: 'EN' };
      this.translateService.use('en-US');
      return;
    }

    this.getAllLanguages();
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  changeLang(locale: string) {
    this.setLanguage(locale);
    this.isDropdownOpen = false;
  }

  getAllLanguages() {
    this.api.allPostMethod('MasterLanguage/MasterLanguageGetAll', {}, true).subscribe({
      next: (res: any) => {
        if (!res['error'] && res['data']) {
          this.languages.set(res['data']);
          this.getLangById()
        } else {
          this.toastr.error(res.message || 'Something went wrong!!')
        }
      },
      error: (error) => {
        this.toastr.error(error.message || 'Something went wrong!!')
      }
    })
  }
  getLangById() {
    this.api.allPostMethod('UserLanguage/GetUserLangugeById', { userId: this.userId() }, true).subscribe({
      next: (res: any) => {
        if (!res['error'] && res['data']) {
          this.selectedLang = res['data'];
          this.setLanguage(this.selectedLang.locale)
        } else {
          this.setLanguage(null)
        }
      },
      error: (error) => {
        this.toastr.error(error.message || 'Something went wrong!!')
      }
    })
  }

  setLanguage(locale: any) {
    locale = locale ? locale : 'en-US';
    const selectedLanguage = this.languages().find((l: any) => l.locale == locale);
    if (selectedLanguage) {
      this.selectedLang = selectedLanguage;
      this.translateService.use(this.selectedLang.locale || 'en-US');
      this.addLangForUser();
      return;
    }

    this.selectedLang = { locale: 'en-US', languageCode: 'EN' };
    this.translateService.use('en-US');
  }
  addLangForUser() {
    if (isHubSpotUrl(this.router.url)) {
      return;
    }
    this.api.allPostMethod('UserLanguage/AddChangeUserLanguage', { userId: this.userId(), languageId: this.selectedLang.languageId }, true).subscribe({
      next: (res: any) => {
        if (!res['error']) {
          console.log('Langauage added successfully')
        } else {
          console.log(res.message)
        }
      },
      error: (error) => {
        this.toastr.error(error.message || 'Something went wrong!!')
      }
    })
  }
}
